<template>
  <div
    class="resultRow"
    :class="{'resultRow--details-visible': detailsVisible}">
    <div class="header">
      <div class="ce-col ce-col-actionsBefore">
        <a
          class="rowToggle"
          href=""
          @click.prevent="toggleDetails">
          <fa-icon icon="angle-down" />
        </a>
      </div>

      <div
        class="ce-col ce-col-color"
        @click.prevent="toggleDetails">
        <div class="resultRow-colorWrapper">
          <img
            class="resultRow-image"
            v-if="image"
            :src="image"
            :alt="row.title">

          <ColorSpaceBadge
            v-else-if="color"
            :color="color" />
        </div>
      </div>

      <div
        class="ce-col ce-col-shadeName cursor-pointer"
        @click.prevent="toggleDetails">
        {{ row.title }}

        <fa-icon
          v-if="hasInternalFormulations"
          transform="up-6 shrink-4"
          icon="lock" />
      </div>
      <div class="ce-col ce-col-actionsAfter" />
    </div>

    <transition
      :css="false"
      @enter="enterAnimation"
      @leave="leaveAnimation">
      <div
        class="details"
        v-if="detailsVisible">
        <div class="detailsHeadline">
          Formulations
        </div>

        <FormulationRow
          v-for="formulation in row.formulations"
          :key="`formulation-${formulation.id}`"
          :row="formulation"
          :shade="row" />
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import slideAnimation from 'mixins/slideAnimation';
import FormulationRow from 'components/formulation-repo/FormulationRow.vue';
import ColorSpaceBadge from 'components/ColorSpaceBadge.vue';

export default {
  components: { ColorSpaceBadge, FormulationRow },
  data() {
    return {
      detailsVisible: false,
    };
  },
  props: {
    row: {
      type: Object,
      required: true,
    }
  },
  mixins: [slideAnimation],
  computed: {
    ...mapState(['fieldManifest']),
    ...mapState('generic', ['links']),
    ...mapState('user', ['activeUser']),
    ...mapGetters('user', ['token']),
    hasInternalFormulations() {
      return !!this.row.formulations.find((f) => f.acl.code === 'internal');
    },
    color() {
      if (this.row.color) {
        return this.fieldManifest.color_space.optionsConfig.find((c) => c.code === this.row.color);
      }

      return null;
    },
    image() {
      if (this.row.imgUrl) {
        return this.row.imgUrl;
      }

      if (this.row.stackPreviewImage?.url) {
        return this.row.stackPreviewImage.url;
      }

      return null;
    }
  },
  methods: {
    showDetails() {
      this.detailsVisible = true;
    },
    hideDetails() {
      this.detailsVisible = false;
    },
    toggleDetails() {
      if (this.detailsVisible) {
        this.hideDetails();
      } else {
        this.showDetails();
      }
    },
  }
};
</script>

<style lang="less">
@import (reference) '~styles/includes/base';

.ce-formulationRepo .resultRow {
  .noselect;

  .header {
    display: flex;
    align-items: center;
    border-bottom: 1px solid @color-mono-92;
    transition: all 250ms ease-in-out;
    padding: 0 @space-2;

    &:hover {
      background: @color-mono-80;
    }

    > div {
      padding: @space-3 0;
    }
  }

  .resultRow-colorWrapper {
    .ce-colorBadge-holder {
      .ce-colorBadge {
        width: 10px;
        height: 20px;
        margin: 0;
      }
    }

    .resultRow-image {
      width: 10px;
      height: 20px;
      border-radius: @border-radius;
      overflow: hidden;
      margin-right: @space-2;
    }
  }

  .rowToggle {
    svg {
      transition: all 250ms ease-in-out;
    }
  }

  &.resultRow--details-visible {
    .rowToggle {
      svg {
        transform: rotate(180deg);
      }
    }
  }

  .details {
    padding-left: (25px + 34px); // width column "actionsBefore" + "color"

    .detailsHeadline {
      text-transform: uppercase;
      font-weight: bold;
      .ms(-1);
      padding: @space-3 @space-2 @space-2;
    }
  }

  &:nth-child(even) {
    background: @color-mono-92;

    &.resultRow--details-visible .header {
      border-bottom-color: @color-mono-80;
    }

    .details {
      .formulationRow {
        border-bottom-color: @color-mono-80;
      }
    }
  }
}
</style>
